import { cva } from 'class-variance-authority';

/**
 * Slideout modal container variants.
 */
export const slideoutModalContainerVariants = cva('fixed inset-0 z-50 flex w-screen', {
  variants: {
    isOpen: {
      false: 'invisible',
      true: 'visible',
    },
    side: {
      left: 'justify-start',
      right: 'justify-end',
    },
  },
  defaultVariants: {
    isOpen: false,
    side: 'right',
  },
});

/**
 * Slideout modal backdrop variants.
 */
export const slideoutModalBackdropVariants = cva(
  'absolute inset-0 bg-neutral-black transition-opacity duration-300',
  {
    variants: {
      isOpen: {
        false: 'opacity-0',
        true: 'opacity-50',
      },
    },
    defaultVariants: {
      isOpen: false,
    },
  },
);

/**
 * Slideout modal panel variants.
 */
export const slideoutModalPanelVariants = cva(
  [
    'bg-neutral-gray-000 shadow-xl',
    'flex flex-col',
    'h-full w-full relative',
    'transition transition-transform duration-300 ease-in-out',
  ].join(' '),
  {
    variants: {
      isOpen: {
        false: '',
        true: 'translate-x-0',
      },
      side: {
        left: '',
        right: '',
      },
    },
    compoundVariants: [
      {
        className: '-translate-x-full',
        isOpen: false,
        side: 'left',
      },
      {
        className: 'translate-x-full',
        isOpen: false,
        side: 'right',
      },
    ],
    defaultVariants: {
      isOpen: false,
      side: 'right',
    },
  },
);

/**
 * Slideout modal panel body styles.
 */
export const slideoutModalPanelBodyStyles = [
  'bg-neutral-gray-000',
  'flex-1',
  'overflow-y-scroll',
].join(' ');

/**
 * Slideout modal header variants.
 */
export const slideoutModalHeaderVariants = cva(
  'bg-neutral-gray-000 border-b border-solid border-semantic-globals-border',
  {
    variants: {
      hasTitle: {
        false: 'relative min-h-16',
        true: 'flex items-center justify-between p-6',
      },
    },
    defaultVariants: {
      hasTitle: true,
    },
  },
);

/**
 * Slideout modal title styles.
 */
export const slideoutModalTitleStyles = [
  'font-bold',
  'font-display',
  'leading-section-subtitle',
  'text-neutral-black',
  'text-section-subtitle',
  'whitespace-nowrap',
].join(' ');

/**
 * Slideout modal close button variants.
 */
export const slideoutModalCloseButtonVariants = cva('text-neutral-black', {
  variants: {
    hasTitle: {
      false: 'absolute right-4 top-4 z-10',
      true: '',
    },
  },
  defaultVariants: {
    hasTitle: true,
  },
});
